import OpportunityStatus from './OpportunityStatus'

export default OpportunityStatus
